(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('lender-integration-blacklist', {
            parent: 'entity',
            url: '/lender-integration-blacklist?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'valueconnectApp.lenderIntegrationBlacklist.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/lender-integration-blacklist/lender-integration-blacklists.html',
                    controller: 'LenderIntegrationBlacklistController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('lenderIntegrationBlacklist');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('lender-integration-blacklist-detail', {
            parent: 'entity',
            url: '/lender-integration-blacklist/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'valueconnectApp.lenderIntegrationBlacklist.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/lender-integration-blacklist/lender-integration-blacklist-detail.html',
                    controller: 'LenderIntegrationBlacklistDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('lenderIntegrationBlacklist');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'LenderIntegrationBlacklist', function($stateParams, LenderIntegrationBlacklist) {
                    return LenderIntegrationBlacklist.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('lender-integration-blacklist.new', {
            parent: 'lender-integration-blacklist',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lender-integration-blacklist/lender-integration-blacklist-dialog.html',
                    controller: 'LenderIntegrationBlacklistDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                remoteLenderId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('lender-integration-blacklist', null, { reload: true });
                }, function() {
                    $state.go('lender-integration-blacklist');
                });
            }]
        })
        .state('lender-integration-blacklist.edit', {
            parent: 'lender-integration-blacklist',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lender-integration-blacklist/lender-integration-blacklist-dialog.html',
                    controller: 'LenderIntegrationBlacklistDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['LenderIntegrationBlacklist', function(LenderIntegrationBlacklist) {
                            return LenderIntegrationBlacklist.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('lender-integration-blacklist', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('lender-integration-blacklist.delete', {
            parent: 'lender-integration-blacklist',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lender-integration-blacklist/lender-integration-blacklist-delete-dialog.html',
                    controller: 'LenderIntegrationBlacklistDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['LenderIntegrationBlacklist', function(LenderIntegrationBlacklist) {
                            return LenderIntegrationBlacklist.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('lender-integration-blacklist', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
